import { Grid } from "@mui/material"
import { PageTitle } from "../../layoutPages/components/PageTitle"
import { DefaultSetting } from "../../layoutPages/defaultSetting"
import { MyColorButton } from "../../layoutPages/components/MyColorButton"
import { ShortCut } from "../../system/ShortCut";
import { MainCard } from "../../layoutPages/components/MainCard";
import { Navigate, useNavigate } from "react-router-dom";


export function ParentMeetingTopButtons() {
    const navigate = useNavigate();
    let thisPageData: Array<{ id: string, value: string, onClick: Function }> = [
        {
            id: "s", value: "理事會架構",
            onClick: () => { ShortCut.windowOpen("https://www.pkppf.hk/p/42489") }
        },
        {
            id: "photo", value: "活動花絮",
            onClick: () => { navigate("/parentMeeting/parentPhoto") }
        },
        {
            id: "in", value: "入會申請",
            onClick: () => { navigate("/parentMeeting/application") }

        },
        {
            id: "contact", value: "聯絡我們",
            onClick: () => { navigate("/parentMeeting/contactUs") }
        }
    ];

    return (<>
        <Grid item xs={11} sm={10} >
            <br></br>
            <PageTitle title='培小舊生家長會' size='h3' sx={{ m: 2, color: DefaultSetting.mainColor }} />
        </Grid>
        <Grid item xs={11} sm={10}>
            <Grid container direction="row" justifyContent="center" alignItems="center" spacing={2} width={"100%"}>
                {
                    thisPageData.map((item) => (
                        <Grid item xs={6} sm={3} >
                            <MyColorButton mainColor={DefaultSetting.mainColor} inverted={true}
                                sx={{ fontSize: "1.2em", width: "100%", borderRadius: "10px", p: 1 }}
                                onClick={() => item.onClick()}
                            >
                                {item.value}
                            </MyColorButton>
                        </Grid>
                    ))
                }
            </Grid>
        </Grid>
    </>)
}